export const borderRadius = {
  small: 4,
  medium: 7,
  large: 12,
  round: 50,
  
  // MUI-compatible values (used directly in sx prop)
  mui: {
    small: 1,   // 8px (1 * 8)
    medium: 2,  // 16px (2 * 8) - common for buttons, cards
    large: 3,   // 24px (3 * 8)
  },
} as const;